export default "RiddleRoom opened in February 2017 and closed in the beginning of 2021.";